import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.castl.ro",  //development
});

export default axiosInstance;
